import { hasSegmentFlag, hasSubscriptionFlag } from '@/data/flags/local-flags';
import { activeSubHasPurchasedProductLine } from '@/data/flags/product-lines.js';

export const FlagsPlugin = {
    install: (app) => {
        app.config.globalProperties.$segmentFlag = hasSegmentFlag;
        app.config.globalProperties.$subFlag = hasSubscriptionFlag;
        app.config.globalProperties.$productLine = activeSubHasPurchasedProductLine;
    },
};
